import { render } from "./MentalList.vue?vue&type=template&id=792a2960"
import script from "./MentalList.vue?vue&type=script&lang=js"
export * from "./MentalList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__